export const REDUCER_KEY = 'committedProposal';
